module.exports = __webpack_public_path__ + "static/index/img/baikal-401.f28106aa.jpg";